import { render, staticRenderFns } from "./ReopenChat.vue?vue&type=template&id=74c32c56&"
import script from "./ReopenChat.vue?vue&type=script&lang=js&"
export * from "./ReopenChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports